import ErrorPage from '../error/errorPage';
import useGlobalError from '../../hooks/useGlobalError';
import PropTypes from 'prop-types';

const WithGlobalError = ({ children }) => {
  const globalError = useGlobalError();
  if (globalError) {
    return <ErrorPage message={globalError} />;
  }
  return children;
};

WithGlobalError.propTypes = {
  children: PropTypes.node
};

export default WithGlobalError;
